import { render } from "./CodeHighlighter.vue?vue&type=template&id=04d89187&ts=true"
import script from "./CodeHighlighter.vue?vue&type=script&lang=ts"
export * from "./CodeHighlighter.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__